import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

const ResetPassword = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [securityAnswer1, setSecurityAnswer1] = useState('');
  const [securityAnswer2, setSecurityAnswer2] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('New password and confirmation do not match');
      return;
    }
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/reset-password', {
        name,
        phone,
        mother_maiden_name: securityAnswer1,
        city_born: securityAnswer2,
        new_password: newPassword
      });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="card" style={{ maxWidth: '400px', margin: '50px auto' }}>
        <h2>Password reset</h2>
        <p style={{ color: '#28a745', marginBottom: '20px' }}>
          Your password has been reset. You can now log in with your new password.
        </p>
        <Link to="/login" className="btn btn-primary">Go to Login</Link>
      </div>
    );
  }

  return (
    <div className="card" style={{ maxWidth: '400px', margin: '50px auto' }}>
      <h2>Reset password</h2>
      <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
        Enter your name, phone, and security answers to set a new password.
      </p>
      {error && <div style={{ color: 'red', marginBottom: '15px' }}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name *</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Phone *</label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>What is your mother's maiden name? *</label>
          <input
            type="text"
            value={securityAnswer1}
            onChange={(e) => setSecurityAnswer1(e.target.value)}
            placeholder="Your answer"
            required
          />
        </div>
        <div className="form-group">
          <label>What is the city you were born? *</label>
          <input
            type="text"
            value={securityAnswer2}
            onChange={(e) => setSecurityAnswer2(e.target.value)}
            placeholder="Your answer"
            required
          />
        </div>
        <div className="form-group">
          <label>New password *</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            minLength={6}
            placeholder="At least 6 characters"
            required
          />
        </div>
        <div className="form-group">
          <label>Confirm new password *</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            minLength={6}
            placeholder="Re-enter new password"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Resetting...' : 'Reset password'}
        </button>
      </form>
      <p style={{ marginTop: '15px' }}>
        <Link to="/login">Back to Login</Link>
      </p>
    </div>
  );
};

export default ResetPassword;
